import { EmptyNotificationsIllustration } from "@/components/illustrations/empty-notifications-illustration";

export function NotificationListEmpty({
  title = "You don't have any notifications",
  description = "We'll notify you about important updates and any time you're mentioned on Arbi",
}: {
  title?: string;
  description?: string;
} = {}) {
  return (
    <div className="flex flex-col items-center">
      <div className="w-full overflow-hidden">
        <EmptyNotificationsIllustration priority />
      </div>
      <div className="flex flex-col items-center p-3 gap-2 w-full">
        <p className="text-sm font-medium leading-4 text-heading whitespace-nowrap">
          {title}
        </p>
        <p className="w-64 text-center text-xs font-normal leading-4 text-contrast/60 dark:text-contrast/70">
          {description}
        </p>
      </div>
    </div>
  );
}
